import React, { useState, useEffect } from "react";
import get from "lodash/get";
import Label from "components/Form/Label";
import InputGroup from "components/Form/InputGroup";
import TextInput from "components/Form/TextInput";
import NextButton from "../NextButton";
import PreviousButton from "../PreviousButton";
import Dropdown from "../../../components/Dropdown/Dropdown";
import { MailIcon } from "lucide-react";
import ProgressBar from "../ProgressBar";
import { booleanOptions, creatorContactOptions } from "consts/general";
import { isEmailValid } from "helpers/utils";

const Step = ({
  onChange,
  formData,
  prevStep,
  nextStep,
  onUserSignUpByStep,
  currentStep,
  totalSteps,
}) => {
  const [hasError, setHasError] = useState(false);
  const [errorMessage, setErrorMessage] = useState({});

  const onFormValidation = (_data) => {
    let result = {};
    let hasInvalidInput = false;
    const manager = get(_data, "manager_represented", "");
    const managerName = get(_data, "manager_name", "");
    const managerEmail = get(_data, "manager_email", "");
    const managerContact = get(_data, "manager_reach_out", "");

    if (manager === null) {
      hasInvalidInput = true;
      result.manager = !manager
        ? "Please select an option"
        : "This field is required.";
    } else {
      if (manager) {
        if (!managerName) {
          hasInvalidInput = true;
          result.manager_name = !managerName
            ? "Please enter a manager name."
            : "This field is required.";
        }

        if (!isEmailValid(managerEmail)) {
          hasInvalidInput = true;
          result.manager_email = !managerEmail ? "" : "Invalid email address.";
        }

        if (!managerEmail) {
          hasInvalidInput = true;
          result.manager_email = !managerEmail
            ? "Please enter a manager email."
            : "This field is required.";
        }

        if (!managerContact) {
          hasInvalidInput = true;
          result.manager_reach_out = !managerContact
            ? "Please enter a manager contact."
            : "This field is required.";
        }
      } else {
        hasInvalidInput = false;
      }
    }

    setHasError(hasInvalidInput);
    setErrorMessage(result);
    return hasInvalidInput;
  };

  useEffect(() => {
    if (hasError) onFormValidation(formData);
  }, []);
  // removed [hasError, formData] for the dependency array to only update errors on the next button click
  return (
    <div className="mx-auto w-full lg:w-[480px]">
      <div>
        <h1 className="my-4 text-2xl md:text-3xl font-bold tracking-tight text-primary-700">
          Let’s talk 🤙
        </h1>
        <p className="mt-2 text-sm text-primary-700">
          Communication preferences.
        </p>
      </div>
      <div className="mt-8">
        <ProgressBar currentStep={currentStep} totalSteps={totalSteps} />
        <form action="#" method="POST" className="space-y-6">
          <div>
            <Label>Are you represented by an agency or manager?</Label>
            <Dropdown
              placeholder="Please select"
              value={
                formData.manager_represented !== null &&
                booleanOptions.find(
                  (option) =>
                    (option.value === "yes" && formData?.manager_represented) ||
                    (option.value === "no" && !formData?.manager_represented)
                )
              }
              options={booleanOptions}
              onChange={(selected) =>
                onChange(
                  {
                    ...formData,
                    manager_represented:
                      selected.value === "yes" ? true : false,
                  },
                  setHasError(false)
                )
              }
              error={hasError ? get(errorMessage, "manager", "") : null}
              required
            />
          </div>
          {formData?.manager_represented && (
            <>
              <div>
                <Label>Manager name</Label>
                <TextInput
                  id="manager_name"
                  name="manager_name"
                  type="text"
                  autoComplete="manager_name"
                  placeholder="Manager Co"
                  value={formData?.manager_name}
                  onChange={(value) =>
                    onChange({ ...formData, manager_name: value })
                  }
                  hasError={
                    hasError ? get(errorMessage, "manager_name", "") : null
                  }
                  required
                />
              </div>
              <InputGroup
                id="manager_email"
                name="manager_email"
                type="email"
                label={"Manager email"}
                placeholder="manager@example.com"
                value={formData?.manager_email}
                // onBlur={() => {
                //   if (hasError) onFormValidation(formData);
                // }}
                hasError={
                  hasError ? get(errorMessage, "manager_email", "") : null
                }
                onChange={(value) =>
                  onChange({ ...formData, manager_email: value })
                }
                Icon={() => <MailIcon className="h-5 w-5 text-gray-400" />}
              />
              <div>
                <Label>Who do we reach out to?</Label>
                <Dropdown
                  placeholder="Please select"
                  options={creatorContactOptions}
                  value={creatorContactOptions.find(
                    (option) => option.value === formData?.manager_reach_out
                  )}
                  onChange={(selected) =>
                    onChange({
                      ...formData,
                      manager_reach_out: selected.value,
                    })
                  }
                  error={
                    hasError ? get(errorMessage, "manager_reach_out", "") : null
                  }
                  required
                />
              </div>
            </>
          )}

          <div className="w-full flex justify-between">
            <PreviousButton onClick={prevStep} />
            <NextButton
              onClick={() => {
                if (!onFormValidation(formData)) {
                  onUserSignUpByStep(nextStep);
                }
              }}
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default Step;
